export const CustomFieldsFormConstants = {
  MaxLengthValueForCustomFields: 64,
  RegexValueForCustomFields: /^[^\s<>][^<>]*$/,
};
